// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__zkVq3","pageButton":"Pagination_pageButton__u3yaq","active":"Pagination_active__8sFY1","ellipsis":"Pagination_ellipsis__JfS5i"};